import { Vue } from "vue-property-decorator";
import { BehaviorSubject } from "rxjs";

/// Val: Global value and Global Observables

type RealType<T> = T extends BehaviorSubject<infer U> ? U : never;
type GlobalType = typeof $global;
export type RealGlobalType<T> = {
    [P in keyof T]?: RealType<T[P]>;
};
declare module "vue/types/vue" {
    export interface Vue extends RealGlobalType<GlobalType> {}
}

export const $global = {
    // cameras$: new BehaviorSubject<IValue>({}),
};

declare module "vue/types/vue" {
    export interface Vue {
        $global: typeof $global;
    }
}

export const GlobalPlugin = {
    install: function (Vue: any) {
        if (Vue._val_global_installed) return;
        Vue._val_global_installed = true;

        Vue.mixin({
            subscriptions: () => {
                return $global;
            },
        });
    },
};

const userType = {
    Administrator: "w_UserAdministrator",
};

const eventType = {
    1: "w_EventLogin",
    2: "w_EventLogout",

    901: "w_EventLineMessageError",
};

const cameraType = {
    rtsp: "rtsp",
};

const smtpType = {
    0: "w_Custom",
    1: "Gmail",
    2: "Hotmail",
    3: "iCloud",
    4: "Naver",
    5: "OpenMailBox",
    6: "Outlook365",
    7: "Yahoo",
};

const triggerType = {
    "Triggers.LINE": "Triggers.LINE",
    "Triggers.Email": "Triggers.Email",
};
function triggerGetIcon(value: string) {
    let len = 22;
    switch (value) {
        case "Triggers.LINE":
            return `<img class="type-icon" style="width:${len}px;height:${len}px" src="/public/LINE_icon.png" />`;
        case "Triggers.Email":
            return `<img class="type-icon" style="width:${len}px;height:${len}px" src='/public/EMAIL_icon.png' />`;
        default:
            return `[${value}]`;
    }
}
function triggerGetText(value: string) {
    return value.replace(/^Triggers\./, "");
}

export const Global = {
    userType,
    eventType,
    cameraType,
    smtpType,

    triggerType,
    triggerGetIcon,
    triggerGetText,
};
